<template>
  <button
    class="cf-header-button cf-header-button--secondary cf-header-button--mobile-hidden"
    type="button"
    title="Sign In"
    @click="handleButtonClick"
  >
    Sign In
  </button>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'CfSignInButton',

    computed: {
      ...mapGetters('merchant', ['loyaltyOptions']),

      isLoyaltySignOnEnabled() {
        return this.loyaltyOptions.supportsLoyaltySso;
      }
    },

    methods: {
      handleButtonClick() {
        if (this.isLoyaltySignOnEnabled) {
          this.$openModal('single-sign-on-modal');
        }
        else {
          this.$openModal('signIn');
        }
      }
    }
  };
</script>
